import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruthruns0postPostScreenTruthRunsResponseSchema = jsonObject
export type tcpscreentruthruns0postPostScreenTruthRunsResponse = z.infer<typeof tcpscreentruthruns0postPostScreenTruthRunsResponseSchema>
